var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.incomplete)?_c('v-chip',{attrs:{"small":"","color":"#FB7672","text-color":"#1b1b1b","data-testid":_vm.testId,"aria-label":"Sign-up incomplete"}},[_vm._v(" Incomplete ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }